import { useState, useEffect, useRef} from "react";
import "./FormThemeColorPicker.css";
import { FormThemeExtended } from "effno-core";
import { ChromePicker } from 'react-color';
import { set } from "react-datepicker/dist/date_utils";


const FALLBACK_COLOR = "#FFFFFF";

type FormThemeColorPickerProps = {
    color: string | undefined;
    type: string;
    onChange: (type: string, newValue: string) => void;
    onComplete: () => void;
}

export const FormThemeColorPicker = ({color, type, onChange, onComplete} : FormThemeColorPickerProps) => {

    const pickerRef = useRef<HTMLDivElement>(null);

    const [pickerOpen, setPickerOpen] = useState<boolean>(false);
    const [theColor, setTheColor] = useState<string | undefined>(color);

    useEffect(() => {
        // Attach the click event listener
        document.addEventListener("mousedown", eventClickOutside);
        document.addEventListener("keydown", eventKeyDown, true);
        
        return () => {
            // Cleanup the event listener on unmount
            document.removeEventListener("mousedown", eventClickOutside);
            document.removeEventListener("keydown", eventKeyDown, true);

        }
    }, []);

    const eventKeyDown = (event: any) => {
        if (event.key === "Escape") {
            // event.preventDefault();
            event.stopPropagation();
            setPickerOpen(false);
            onComplete();
        }
    }

    const eventClickOutside = (event: any) => {
        if (pickerRef && pickerRef.current && !pickerRef.current.contains(event.target)) {
            console.log("Clicked outside the div: ", theColor);
            setPickerOpen(false);
            onComplete();
        }

       // or do nothing
    }
    
    const handleChangeColor = (color: any) => {
        console.log("new color: ", color);
        setTheColor(color.hex); 
        onChange(type, color.hex);
    }

    const handleChangeColorComplete = (color: any, event: any) => {
        console.log("complete: ", color);
        setTheColor(color.hex); 
        onChange(type, color.hex);
    };

    return (
        <div 
            className="form-theme-color-picker" 
        >
            <div className="form-theme-color-picker-hex">
               {color?.toLocaleLowerCase()}
            </div>
            <div 
                className="form-theme-color-picker-block"
                style={{backgroundColor: color ? color : FALLBACK_COLOR}}
                onClick={()=>setPickerOpen(!pickerOpen)}
            > 
            </div>
            {/* <div className="form-theme-color-picker-name">
                {color ? color : FALLBACK_COLOR}
            </div> */}

            {pickerOpen &&
                <div 
                    className="form-theme-color-picker-container"
                    onClick={(e: any) => e.stopPropagation()}
                    ref={pickerRef}
                >
                    <ChromePicker 
                        color={theColor ? theColor : FALLBACK_COLOR}
                        onChange={handleChangeColor}
                        onChangeComplete={handleChangeColorComplete}
                    />
                    {}
                </div>   
            }  
        </div>
    )
}